module.exports = __webpack_public_path__ + "static/media/yt.0d405094.svg";